<button
  #trigger="cdkOverlayOrigin"
  (click)="toggleAide()"
  hlmBtn
  variant="ghost"
  size="icon"
  cdkOverlayOrigin
  aria-label="Centre d'aide"
  hlmTooltipTrigger="Centre d'aide"
>
  <ng-icon name="lucideCircleHelp" />
</button>

<ng-template
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="aideEstOuvert()"
  (overlayOutsideClick)="toggleAide()"
  cdkConnectedOverlay
>
  <app-aide (onClose)="toggleAide()"></app-aide>
</ng-template>
